import { useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { EventEditController } from "./event-edit-controller";
import { EventEditPage } from "./event-edit-page";

/** `/events/new` and `/events/:eventId/edit`. */
export function EventEditRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const { eventId = null } = useParams<{ eventId: string }>();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return (
    <Subtree
      key="event-edit"
      deps={[eventId]}
      controller={() =>
        new EventEditController(
          pick(deps, "client", "authHandler", "storeRepository", "locationsRepository", "countriesRepository"),
          { eventId, timeZone },
          {
            toShow: (id) => navigate(`/events/${id}`),
            toList: () => navigate("/events"),
          },
        )
      }
    >
      <EventEditPage />
    </Subtree>
  );
}
